/**
 * @desc 校验确认登录密码是否一致
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** 确认登录密码 */
  confirmPassword: string;
  /** 新登录密码 */
  newPassword: string;
}

export function request(params: Params): Promise<defs.StandardReturn<boolean>> {
  return defHttp.get({
    url: '/web/user/checkConfirm',

    params,
  });
}

export function mock(params: Params): Promise<defs.StandardReturn<boolean>> {
  return defHttp.get({
    url: '/mock/web/user/checkConfirm',

    params,
  });
}
